<template>
  <el-card class="mgb20" shadow="always">
    <div class="searchWrapper">
      <div class="searchContent" v-if="showSearch">
        <div
          v-for="(item, index) in searchConfig"
          :key="index + 'search'"
          class="searchItem"
        >
          <el-tooltip placement="top" :content="item.cnName">
            <div class="searchLabel">{{ item.cnName }}</div>
          </el-tooltip>
          <TextSearch
            v-if="item.rules.type == 'text'"
            :data.sync="formData[item.enName]"
            :config="item"
          ></TextSearch>
          <SelectSearch
            v-if="item.rules.type == 'select'"
            :data.sync="formData[item.enName]"
            :config="item"
          ></SelectSearch>
          <DateSearch
            v-if="item.rules.type == 'date'"
            :data.sync="formData[item.enName]"
            :config="item"
          ></DateSearch>
        </div>
        <el-button type="primary" icon="el-icon-refresh-right" @click="refresh"
          >清空搜索</el-button
        >
      </div>
      <p v-else>表格操作<slot name="headSearch"></slot></p>
      <div>
        <slot></slot>
      </div>
    </div>
  </el-card>
</template>
<script>
import SelectSearch from "../search/SelectSearch.vue";
import DateSearch from "../search/DateSearch.vue";
import TextSearch from "../search/TextSearch.vue";
export default {
  name: "NewSearch",
  components: { TextSearch, SelectSearch, DateSearch },
  props: ["searchConfig", "showSearch"],
  watch: {
    formData: {
      deep: true,
      handler(val) {
        if (val) {
          let i = 0;
          let params = {};
          for (i in val) {
            // 排除空数组、空字符串
            if (val[i] && val[i].length > 0) {
              params[i] = val[i] instanceof Array ? val[i].join(",") : val[i];
            }
          }
          this.searchFun(params);
        }
      },
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  methods: {
    searchFun(val) {
      this.$emit("searchFun", val);
    },
    refresh() {
      this.formData = {};
    },
  },
};
</script>
